export default __webpack_public_path__ + "static/media/avatar.2e19598f.svg";